"use client";

import { useEffect } from "react";

/**
 * 注册 PWA Service Worker（仅生产模式注册，dev 下 SW 会干扰 HMR）。
 * - 页面回到前台时检查更新，发现新版本自动激活（skipWaiting）。
 * - 需 HTTPS 或 localhost 才能安装到手机。
 */
export default function ServiceWorkerRegister() {
  useEffect(() => {
    if (process.env.NODE_ENV !== "production") return;
    if (!("serviceWorker" in navigator)) return;

    const register = () =>
      navigator.serviceWorker.register("/sw.js").then((reg) => {
        // 发现新 SW 时立即激活，避免旧缓存拖到下次访问
        reg.addEventListener("updatefound", () => {
          const newWorker = reg.installing;
          if (!newWorker) return;
          newWorker.addEventListener("statechange", () => {
            if (newWorker.state === "installed" && navigator.serviceWorker.controller) {
              newWorker.postMessage({ type: "SKIP_WAITING" });
            }
          });
        });
      });

    register().catch(() => {
      /* 注册失败不打扰用户 */
    });

    const onVisible = () => {
      if (document.visibilityState === "visible") {
        navigator.serviceWorker.getRegistration().then((reg) => reg?.update());
      }
    };
    document.addEventListener("visibilitychange", onVisible);
    return () => document.removeEventListener("visibilitychange", onVisible);
  }, []);

  return null;
}